<template>
<!-- 个人中心 -->
  <div>

    <div class="personCenter">
      <nav>注册人信息</nav>
      <div class="cardBox">
        <form action="">
          <p>
            <span>
              姓名
            </span>
            <span>{{ userList.nickname }}</span>
          </p>

          <p>
            <span class="sex">
              性别
            </span>
            <span v-if="userList.sex == 0">女</span>
            <span v-else-if="userList.sex ==1">男</span>
          </p>

          <p>
            <span>
              生日<img src="../assets/icon_xinghao@2x.png" alt="">
            </span>
            <span>
              {{ userList.birthday }}
              <img @click="showTimePopup" src="../assets/pan_icon@2x.png" alt="修改">
            </span>
          </p>

          <p>
            <span>
              电话<img src="../assets/icon_xinghao@2x.png" alt="">
            </span>
            <span>
              <input type="text" name="firstname" maxlength="11" pattern="[0-9]" v-model="userList.telephone">
              <img src="../assets/pan_icon@2x.png" alt="修改">
            </span>
          </p>

          <p>
            <span>
              地址<img src="../assets/icon_xinghao@2x.png" alt="">
            </span>
            <span>
              {{ userList.address}}
              <img @click="showPopup" src="../assets/pan_icon@2x.png" alt="修改">
            </span>
          </p>

          <p>
            <span>
              用户级别
            </span>
            <span>{{ lv }}</span>
          </p>
        </form>
      </div>
      <button @click="changeData">修改用户信息</button>
    </div>

    <!-- 修改地址蒙层 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '48%' }">
      <van-area @confirm="onSave" @cancel="onCancel" :area-list="areaList"/>
    </van-popup>

    <!-- 修改生日蒙层 -->
    <van-popup v-model="showTime" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timeSave"
        @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import AddressInfo from '../components/area'
import { Area } from 'vant';
import { Popup } from 'vant';
import { DatetimePicker } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';

Vue.use(Toast);
Vue.use(Area);
Vue.use(Popup);
Vue.use(DatetimePicker);

export default {
  props: {},
  data() {
    return {
      show: false,
      showTime:false,
      userList:{},
      lv: '',
      areaList: AddressInfo,
      currentDate: new Date(),
      minDate: new Date(1900,0,1),
      maxDate: new Date(),
    };
  },
  mounted() {
    // this.getIntegral()
    this.getUser();
  },
  methods: {
    // 获取积分
    getIntegral() {
        this.axios.get('/weixin/center')
        .then((response)=>{
          let credit = response.data.credit
          if ( credit == 0 ) {
            this.lv ="暂无等级";
          }
          if ( credit > 0 && credit < 200) {
            this.lv ="普通会员";
          }
          if (credit >= 200 && credit < 1000 ) {
            this.lv = "高级会员";
          }
          if ( 1000 <= credit && credit <5000) {
            this.lv = "青铜会员";
          }
          if (5000<=credit && credit < 10000) {
            this.lv = "白银会员";
          }
          if (10000<=credit && credit < 20000) {
            this.lv = "黄金会员";
          }
          if (20000<=credit && credit < 30000) {
            this.lv = "白金会员";
          }
          if (30000<=credit && credit < 50000) {
            this.lv = "钻石会员"
          }
          if (50000<=credit) {
            this.lv = "VIP会员";
          }

        }).catch((response)=>{
            Toast('出错了！');
        })
    },


    // 获取个人信息
    getUser() {
        this.axios.get('/weixin/center')
        .then((response)=>{
          this.userList = response.data;
          this.getIntegral()
        })
    },

    // 点击修改生日按钮
    showTimePopup:function(){
      this.showTime = true;
    },

    // 修改时间后缀
    formatter(type, value) {
  　　if (type === 'year') {
    　　return `${value}年`;
  　　} else if (type === 'month') {
  　　  return `${value}月`
  　　} else if (type === 'day') {
    　　return `${value}日`
  　　}
  　　return value;
　　},

    // 修改生日
    timeSave(val) {
      let time = {
        "birthday": val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate()
      }
      this.axios.post('/weixin/updateBir', time)
      .then(res=>{
        //没有绑定设备
        if(res.data.BINDING) {
          Toast('请绑定设备！')
        }
        // 修改生日成功
        if(res.data!=null) {
          this.userList.birthday = time.birthday;
          Dialog.alert({
              message: '修改成功！！'
          }).then(() => {
              this.$router.push({path: '/'})
          });
        }
        this.showTime = false;
      })
    },

    // 点击修改地址按钮
    showPopup() {
      this.show = true;
    },

    // 点击确认修改地址
    onSave(val) {
      this.userList.address = val[0].name +'-'+ val[1].name + '-' + val[2].name
      this.show = false;
    },
    // 点击取消按钮
    onCancel() {
      this.show = false;
      this.showTime = false;
    },

    // 发送修改地址和手机号请求
    changeData() {
      // 验证手机号
      let phone_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if(!phone_rule.test(this.userList.telephone)) {
        Toast('手机号错误！')
        return false
      }
      let data = {
        "telephone": this.userList.telephone,
        "address": this.userList.address
      }
      this.axios.post('/weixin/updateuser', data)
      .then(res=>{
        Dialog.alert({
            message: '修改成功！！'
        }).then(() => {
            this.$router.push({path: '/'})
        });

      })
    }
  },
  components: {}
};
</script>

<style>
.van-hairline--top-bottom button {
  margin-top: 10px;
}

.van-dialog__message {
  line-height: 100px;
}


.van-dialog__confirm, .van-dialog__confirm:active {
  color: #d65746;
}

.van-toast--html, .van-toast--text {
  min-width: 200px;
  min-height: 80px;
}

.van-dialog__footer {
  height: 80px;
  line-height: 80px;
}
</style>

<style scoped>
input {
  border: none;
  width: 240px;
  height: 118px;
  font-size: 34px;
  color: #666;
}
.personCenter button {
  font-size: 40px;
  width: 100%;
  height: 126px;
  letter-spacing: 4px;
  background-color: #d65746;
  color: #fff;
  border-radius: 25px;
  border: none;
  outline: none;
  margin-top: 250px;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

p {
  margin: 0;
  padding: 0;
}
body {
  background: #f8f8f8;
  font-size: 40px;
  font-family: "PingFang-SC-Medium";
  letter-spacing: 4px;
  color: #333333;
}
nav {
  font-size: 40px;
  margin: 36px;
  margin-left: 14px;
}

.personCenter {
  padding:28px;
}

.cardBox {
  background: #fff;
  padding: 0 28px;
  border-radius: 30px;
}

.cardBox p{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 118px;
  border-bottom: 1px solid #f0f0f0;
}

.cardBox p:last-child {
  border-bottom: none;
}

.cardBox p span:first-of-type img {
  width: 10px;
  vertical-align: text-top;
  margin-left: 4px;
}

.cardBox p span:last-of-type {
  font-size: 34px;
  color: #666666;
}

.cardBox p span img {
  width: 30px;
  vertical-align: 0;
}

.personCenter .cardBox p .sex {
  font-size: 44px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/views/User.vue